/**
 * Sous quelle forme écrire un compte dans `Site.accountIds`.
 *
 * ## Pourquoi ce n'est pas toujours le numéro du compte
 *
 * Un site retient ses comptes par une liste d'identifiants, et trois écritures y coexistent :
 * le `cuid` du compte en bibliothèque, son `sourceId`, ou une **forme qualifiée**
 * `{fournisseur}-{connexion}-{source}`. La troisième existe pour Matomo et Piano, dont le numéro
 * de site n'est unique **qu'à l'intérieur d'une instance** : deux instances Matomo ont toutes
 * deux un site n° 1, et le numéro nu ne dirait pas lequel.
 *
 * ⚠️ Écrire le numéro nu pour ces deux fournisseurs ne produit pas une erreur : le rattachement
 * **disparaît silencieusement** à la lecture suivante de `GET /api/sites`, qui nettoie les
 * identifiants qu'il ne sait pas rapporter à un compte existant. On ne s'en aperçoit qu'en
 * constatant un dashboard consolidé vide.
 *
 * Le pendant côté serveur est `backend/src/utils/rattachementComptes.js`, qui sait relire les
 * trois écritures. Celui-ci ne fait que choisir la bonne au moment d'écrire.
 */

/** Les fournisseurs dont le numéro de site n'a de sens qu'au sein de leur connexion. */
const PREFIXES_QUALIFIES = {
  MATOMO: 'matomo',
  MATOMO_OAUTH: 'matomo',
  PIANO_ANALYTICS: 'piano'
};

/**
 * L'identifiant à écrire dans `Site.accountIds` pour ce compte.
 *
 * @param {{type: string, sourceId: string|number, connectionId?: string}} compte
 * @returns {string}
 */
export function identifiantDeRattachement(compte) {
  const prefixe = PREFIXES_QUALIFIES[compte?.type];
  if (!prefixe || !compte?.connectionId) return String(compte?.sourceId ?? '');
  return `${prefixe}-${compte.connectionId}-${compte.sourceId}`;
}

export default identifiantDeRattachement;
